import { render, staticRenderFns } from "./DeleteHapp.vue?vue&type=template&id=d4a1b57a"
import script from "./DeleteHapp.vue?vue&type=script&lang=js"
export * from "./DeleteHapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports